import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { ShuttleComponent } from './shuttle/shuttle.component';
import { LoginComponent } from './login/login.component';
import{ Shuttle_Start_Component } from './shuttle.start/shuttle.start.component';
import { ShuttleEnRouteComponent } from './shuttle-en-route/shuttle-en-route.component';
import { ShuttleAtStopComponent } from './shuttle-at-stop/shuttle-at-stop.component';
import { ShuttleDelayComponent } from './shuttle-delay/shuttle-delay.component';
import { ShuttleDeactivateComponent } from './shuttle-deactivate/shuttle-deactivate.component';
import { ShuttleDeviateRouteComponent } from './shuttle-deviate-route/shuttle-deviate-route.component';
import { ShuttleDeviateEnRouteComponent } from './shuttle-deviate-en-route/shuttle-deviate-en-route.component';
import { ShuttleLoginComponent } from './shuttle-login/shuttle-login.component';
import { ShuttleBreakComponent } from './shuttle-break/shuttle-break.component';
import { ShuttleDeviateStopComponent } from './shuttle-deviate-stop/shuttle-deviate-stop.component';


const routes: Routes = [
     {
       path: '',
       redirectTo: '/login',
       //component: AppComponent
       pathMatch: 'full'

    },
    {
          path:'start',
          component: AppComponent
     },
     {
       path: 'login',
       component: ShuttleLoginComponent
      },
      {
       path: 'shuttle',
       redirectTo: 'shuttle/start',
      },{
       path: 'shuttle/start',
       component: Shuttle_Start_Component
      },{
       path: 'shuttle/en-route',
       component: ShuttleEnRouteComponent
      },
      {
      path: 'shuttle/at-stop',
      component: ShuttleAtStopComponent
      },
      {
      path: 'shuttle/set-delay',
      component: ShuttleDelayComponent
      },
      {
      path: 'shuttle/deactivate',
      component: ShuttleDeactivateComponent
     },{
      path: 'shuttle/break',
      component: ShuttleBreakComponent
      },
      {
      path: 'shuttle/deviate-route',
      component: ShuttleDeviateRouteComponent
      },{
           path: 'shuttle/deviate-en-route',
           component: ShuttleDeviateEnRouteComponent
      },{
           path: 'shuttle/deviate-stop',
           component: ShuttleDeviateStopComponent
           },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {
}
